module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAWCAYAAADeiIy1AAAA4ElEQVRIS+2VvQ3CMBCF31mUllgBZwFKRkIUFAwQUTEBNEyBGCQbJBYSdClNyuhQEC5AAZ/5L3KNm2d/fu9sHQFAkiTcrJ8s+gnIWnsGv7N8WleOOpAk4v+J7tGTj+ll0NHXQJL8JZqgI8khEk0HkqTUqvltdG1XuvkzyhgzIaIFgH6MzeCY8CBjzJCI1gBGMQCvvTsWfLZVVWmt9ZyZZwB6APZKqWme59sYYBAEYAdgwMw1ES2dc2lZlscYSKOVgBpdRkTjoiiyWIA0OgcgtdauANTPQkKONpdeHF4B+L0nd6SIzPT2BSgAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ico-gonggao.png
// module id = RCWm
// module chunks = 1